(function () {
  'use strict';
  var cfg = window.LeDecor || {};

  var lastSubmitter = null;
  var nav = document.getElementById('ldNav');
  var topBtn = document.getElementById('ldTopBtn');
  function onScroll() {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 55);
    if (topBtn) topBtn.classList.toggle('show', window.scrollY > 500);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  function toast(msg) {
    var el = document.getElementById('cartToast');
    if (!el || typeof bootstrap === 'undefined') return;
    if (msg) {
      var body = el.querySelector('.toast-body');
      if (body) body.innerHTML = '<i class="bi bi-check-circle-fill text-success me-2"></i> ' + msg;
    }
    bootstrap.Toast.getOrCreateInstance(el).show();
  }

  function openDrawer() {
    var d = document.getElementById('cartDrawer');
    if (d && typeof bootstrap !== 'undefined') bootstrap.Offcanvas.getOrCreateInstance(d).show();
  }

  function refresh(open) {
    return fetch(window.location.pathname, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['#cart-list', '#cart-total'].forEach(function (sel) {
          var fresh = doc.querySelector(sel), cur = document.querySelector(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        var fb = doc.querySelector('[data-cart-count]'), cb = document.querySelector('[data-cart-count]');
        if (fb && cb) cb.textContent = fb.textContent;
        var fbtn = doc.querySelector('#checkout-btn'), cbtn = document.querySelector('#checkout-btn');
        if (fbtn && cbtn) cbtn.disabled = fbtn.disabled;
        if (open) openDrawer();
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-ld-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      fetch(cfg.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.variantId), quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { toast('Item added to cart!'); return refresh(true); })
        .catch(function () { toast('Could not add that item.'); })
        .then(function () { add.disabled = false; });
      return;
    }
    var rm = e.target.closest('[data-ld-remove]');
    if (rm) {
      e.preventDefault();
      fetch(cfg.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(rm.dataset.line), quantity: 0 })
      }).then(function () { return refresh(false); });
    }
  });

  // Remember which button was pressed, for browsers without event.submitter.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#product-form [type="submit"]');
    if (b) lastSubmitter = b;
  }, true);

  document.addEventListener('submit', function (e) {
    var pf = e.target.closest('#product-form');
    if (pf) {
      e.preventDefault();
      var pressed = e.submitter || lastSubmitter;
      var buyNow = !!(pressed && pressed.hasAttribute('data-buy-now'));
      var buttons = pf.querySelectorAll('[type="submit"]');
      buttons.forEach(function (b) { b.disabled = true; });
      fetch(cfg.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(pf) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (buyNow) {
            window.location.href = '/checkout';
            return null;                      // leave the buttons disabled while we navigate
          }
          toast('Item added to cart!');
          return refresh(true);
        })
        .catch(function () {
          toast('Could not add that item.');
          buttons.forEach(function (b) { b.disabled = false; });
        });
      return;
    }
    var od = e.target.closest('#orderForm');
    if (od) {
      e.preventDefault();
      var attrs = {};
      ['name', 'phone', 'address', 'city'].forEach(function (f) {
        var i = od.querySelector('[name="' + f + '"]');
        if (i) attrs['COD ' + f.charAt(0).toUpperCase() + f.slice(1)] = i.value;
      });
      fetch(cfg.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    }
  });

  var panel = document.getElementById('ldSearchPanel');
  var input = document.getElementById('ldSearchInput');
  window.openSearch = function (e) {
    if (e) e.preventDefault();
    if (!panel) return;
    panel.classList.add('show');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 80);
  };
  window.closeSearch = function (e) {
    if (e && e.target && e.target.id !== 'ldSearchPanel') return;
    if (!panel) return;
    panel.classList.remove('show');
    document.body.style.overflow = '';
  };
  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        window.location.href = cfg.search + '?q=' + encodeURIComponent(input.value) + '&type=product';
      }
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeSearch();
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); window.openSearch(); }
  });

  window.changeDetailImage = function (t) {
    var main = document.getElementById('detail-main-image');
    if (!main) return;
    var src = typeof t === 'string' ? t : (t.dataset.full || t.src);
    main.src = src;
    document.querySelectorAll('.product-detail-thumb').forEach(function (x) {
      x.classList.toggle('active', (x.dataset.full || x.src) === src);
    });
  };
  window.changeDetailQty = function (n) {
    var i = document.getElementById('detail-qty');
    if (i) i.value = Math.max(1, Number(i.value) + n);
  };

  var sort = document.getElementById('ld-sort');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });
})();
